<template>
   <div class="delivery-form-details-info">
      <div class="grid-row">
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="details-block">
            <span class="details-title">{{$_('delivery_information')}} :</span>
            <div class="details-info">
              <span>{{$_('delivery_note_number')}} : {{this.$route.params.delivery_form_id}} du {{$dateformat(tdate_bl)}}</span>
              <span>{{tadr1l}}</span>
              <span>{{tadr2l}}</span>
              <span>{{tadr3l}}</span>
              <span>{{tadr4l}}</span>
              <span>{{tadr5l}}</span>
              <span>{{tcpl}} {{tvillel}}</span>
            </div>
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="details-block">
            <div class="details-info">
              <span>{{$_('carrier')}} : {{tlib_trsp}}</span>
              <span>{{$_('incorterm')}} : {{tlib_port}}</span>
              <span>{{$_('tracking')}} : <a v-if="thttp_track !== ''" target="_blank" :href="thttp_track">{{$_('tracking_link')}}</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import deliveryService from '@/modules/facture/services/deliveryService.js';

export default {
  name: '',
  data() {
    return {
      tadr1l: '',
      tadr2l: '',
      tadr3l: '',
      tadr4l: '',
      tadr5l: '',
      tcpl: '',
      tport: '',
      tlib_port: '',
      tvillel: '',
      tlpaysl: '',
      tdate_bl: '',
      thttp_track: '',
      ttrsp: '',
      tlib_trsp: '',
      tprovl: '',
    }
  },
  created() {
    let pnbl = this.$route.params.delivery_form_id;

    this.display_info = !this.display_info;

    deliveryService.getDeliveryFormDetailsInfo(pnbl)
    .then(res => {
      if(res.data.DS_O !== undefined) { 
        Object.entries(res.data.DS_O.OUT).map((value) => {
          this[value[0].toLowerCase()] = value[1];            
        });
      }

    }).catch(err => {
      console.error(err);
    });
  }
}
</script>

<style scoped>
.delivery-form-details-info {
  background-color: #f9f8f8;
  border: solid 1px rgb(230, 230, 230);
}
.details-block {
  flex-direction: column;
  display: flex;
  color: #585858
}
.details-title {
  font-weight: bold; 
  margin-bottom: 15px;
  color: rgb(142, 141, 141);
}
.details-info {
  display: flex;
  flex-direction: column;
}
.details-info span {
  margin-bottom: 5px;
}
</style>